// index.tsx
import React, { useEffect, useState } from "react";
import { Table,Input } from "antd";
import { DatatableProps } from "../../data/interface";
import { useSelector } from "react-redux";


const Datatable: React.FC<DatatableProps> = ({ columns, dataSource , Selection,pageNo,alltotal,onPageChange,onPageSizeChange,limit,getData,setPage }) => {
  const [selectedRowKeys, setSelectedRowKeys] = useState<any[]>([]);
  const [searchText, setSearchText] = useState<string>("");
  const [Selections, setSelections] = useState<any>(true);
  const [filteredDataSource, setFilteredDataSource] = useState(dataSource);
  const [loading, setLoading] = useState<boolean>(false);
  const [newpageNo,setNewpageNo] = useState(1)
  const onSelectChange = (newSelectedRowKeys: any[]) => {
    setSelectedRowKeys(newSelectedRowKeys);
  };

  const handleSearch = (value: string) => {
    setSearchText(value);
    const filteredData = dataSource.filter((record) =>
      Object.values(record).some((field) =>
        String(field).toLowerCase().includes(value.toLowerCase())
      )
    );
    setFilteredDataSource(filteredData);
  };

  const rowSelection = {
    selectedRowKeys,
    onChange: onSelectChange,
  };
  useEffect(() => {
    return setSelections(Selection);
  }, [Selection])
  const token = useSelector((state:any)=>state.auth.token)
  
  
  return (
    <>

     {/* <div className="table-top-data">
      <div className="row p-3">
          <div className="col-sm-12 col-md-6">
            <div className="dataTables_length" id="DataTables_Table_0_length">
            <div className="col-sm-12  d-flex justify-content-end">
            
                        <Input
                          placeholder="Search Application Id..."
                          value={searchText}
                          onChange={(e) => handleSearch(e.target.value)}
                          style={{ width: 250 }}
                          allowClear
                        />
                      </div>
            </div>
          </div>
         
        </div>
     </div> */}

      <div className="table-top-data">
             <div className="row p-3">
               <div className="col-sm-12  d-flex justify-content-end">
                 <Input
                   placeholder="Search..."
                   value={searchText}
                   onChange={(e) => handleSearch(e.target.value)}
                   style={{ width: 250 }}
                   allowClear
                 />
               </div>
             </div>
           </div>

     {!Selections ?
      <Table
      className="table datanew dataTable no-footer"
     
      columns={columns}
      rowHoverable={true}
      loading={loading}
      dataSource={searchText ? filteredDataSource : dataSource}
      pagination={{
        locale: { items_per_page: "" },
        nextIcon: <i className="ti ti-chevron-right"/>,
        prevIcon: <i className="ti ti-chevron-left"/>,
        defaultPageSize: 10,
        current: newpageNo,
        pageSize: limit,
        total: alltotal,
        showSizeChanger: true,
        pageSizeOptions: ["10", "20", "30"],
        showTotal: (total, range) => 
          `Showing ${range[0]} - ${range[1]} of ${total} entries`,
        //onChange: handlePaginationChange,
        onChange:async  (current, pageSize) => {
          setLoading(true);
         
          setNewpageNo(current)
          setPage(current)
          onPageChange?.(current);      // ✅ Triggers setPage()
          onPageSizeChange?.(pageSize); // ✅ Triggers setlimit()
          await getData(token,current,pageSize)
          setLoading(false);
        },
      }}
    /> : 
    <Table
        className="table datanew dataTable no-footer"
        rowSelection={rowSelection}
        columns={columns}
        rowHoverable={false}
        dataSource={filteredDataSource}
        loading={loading}
        
        pagination={{
          locale: { items_per_page: "" },
          nextIcon: <i className="ti ti-chevron-right"/>,
          prevIcon: <i className="ti ti-chevron-left"/>,
          defaultPageSize: 10,
          total: alltotal,
          showSizeChanger: true,
          pageSizeOptions: ["10", "20", "30"],
          showTotal: (total, range) => `Showing ${range[0]} - ${range[1]} of ${total} entries`,
          
        }}
      />}
      
    </>
  );
};

export default Datatable;
